import { render } from "./Roulette.vue?vue&type=template&id=0a786d45&scoped=true"
import script from "./Roulette.vue?vue&type=script&lang=js"
export * from "./Roulette.vue?vue&type=script&lang=js"

import "./Roulette.vue?vue&type=style&index=0&id=0a786d45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a786d45"]])

export default __exports__